export default [
  {
    path: "/settings",
    name: "settings",
    redirect: "/settings/general/brands",
    icon: "settings",
    meta: {
      title: "Settings",
      parentMenu: true,
      ability: {
        action: "read",
        subject: ["InventoryDaysConfiguration", "Print"],
      },
    },
    children: [
      {
        path: "/settings/inventory-days-configuration",
        name: "settings-inventory-days-configuration",
        icon: "calendar",
        component: () => import("@/views/Settings/InventoryDays.vue"),
        meta: {
          title: "Inventory Days Configuration",
          ability: { action: "read", subject: "InventoryDaysConfiguration" },
        },
      },
      {
        path: "/labels",
        name: "labels",
        icon: "tag",
        component: () => import("@/views/Settings/LabelsList.vue"),
        meta: {
          title: "Labels",
          ability: { action: "read", subject: "Print" },
        },
      },
    ],
  },
];
